import { useEffect } from 'react';

import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';

export const useSetIsDirtyListener = (variable: unknown) => {
  const { isDirty, setDirty } = useApplicationNavigation();

  useEffect(() => {
    if (!!variable && !isDirty) {
      setDirty();
    }
  }, [variable]);
};
